<template>
  <!-- <span> -->
  <i aria-label="图标: container" class="anticon anticon-container">
    <tk-icon style="margin-top: -6px;" :size="16">commodity2</tk-icon>
  </i>
</template>
<script>
export default {
}
</script>
